//Importar React, axios para las peticiones, y react-router-dom.
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';

//Importar imágenes y componentes locales.
import logoLPSoftfrom from "../assets/images/logo-lpsoft.png";

import BtnBorder from "../components/common/Buttons/BtnBorder.jsx";
import Burbujas from "../components/common/Burbujas.jsx";

//Importar el custom hook useForm().
import useForm from "../hooks/useForm";

//Importar las dependencias para el Redux.
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../slices/authSlice.js'

//Importar helpers.
import { hasPermission } from "../helpers/storage/hasPermission.js";
import ComputerWithLogo from "../components/common/Logo/ComputerWithLogo.jsx";
import AlertMessage from "../components/common/Alerts/AlertMessage.jsx";
import ModalActiveSessionsList from "../components/common/Modal/ModalActiveSessionsList.jsx";
import { handleReconnectionSession } from "../helpers/fetch/handleReconnectionSession.js";
import { onHandleLogin } from "../helpers/fetch/onHandleLogin.js";
import ModalSocketConnectionFailed from "../components/common/Modal/ModalSocketConnectionFailed.jsx";
import useDisconnectSocket from "../hooks/useDisconnectSocket.js";

// Login: Componente que renderiza la pantalla de Inicio de Sesión.

const Login = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [messageError, setMessageError] = useState(false); //Estado para mostrar error caso de que falle el login.
    const [openModal, setOpenModal] = useState(false);
    const [sessionActiveData, setSessionActiveData] = useState({});
    const [socketConnect, setSocketConnect] = useState(false);

    //Desestructurar y acceder a los valores del form y a la función para setear sus campos.
    const { form, changed } = useForm({});

    const handleLoginUser = async (e = null) => { //Función para enviar los datos por axios, y navegar a "/Chats" luego de logearse.
        if (e) e.preventDefault();
            const response = await onHandleLogin({ form }); //Realizar la peticion para el login.
            if (response.status === 200) {
                setMessageError(false);
                
                //Verificar si la ruta "/app" se encuentra entre las rutas con los permisos.
                let checkAuth = await hasPermission('/app');

                //Despachar la acción loginSuccess con el nombre del usuario y el dato del
                //array con la autenticación de la ruta "/app".
                dispatch(loginSuccess({ user: response.data.Nombre, permissions: checkAuth }));

                //Redireccionar a "/app".
                await navigate('/app', { replace: true });
            }

            else if (response.response.status === 500 ){
                setSessionActiveData(response.response.data);
                setOpenModal(true);
            }
            else{
                setMessageError(true);
            }
    };
    const onHandleReconnectionSession = async () => {
        let userLogin = form; //Guardar los datos del formulario en userLogin.
        const statusReconnection = await handleReconnectionSession({ 
            userName: userLogin.username, 
            password: userLogin.password, 
            idUsuario: sessionActiveData.IdUsuario
        });
        console.log("volvión un", statusReconnection)
        if (statusReconnection === 200) handleLoginUser();
    };

    /* const socketDisconnected = useDisconnectSocket();
    useEffect(() => {
        if (socketDisconnected) {
            // Realiza cualquier acción adicional aquí si es necesario
            console.log("Socket se ha desconectado en el componente Login");
        }
    }, [socketDisconnected]); */

    return (
        <>
            <div className="container-login__main">
                <div className="container-login__elements-sith-image">

                    {/*------Campo para ingresar los datos del usuario------*/}
                    <div className="container-login__elements">
                        <h1>Iniciar Sesión</h1>
                        <span>Por favor, ingrese su usuario y contraseña</span>
                        <form className="content-form" onSubmit={handleLoginUser}>
                            <input placeholder="Usuario" type='text' name="username" onChange={changed} className="container-login__elements--input" />
                            <input placeholder="Contraseña" type='password' name="password" onChange={changed} className="container-login__elements--input" />
                            {messageError && <AlertMessage text="Usuario o Contraseña incorrectos." />}
                            <BtnBorder />
                        </form>

                        {/*------Logo de LPSoft------*/}
                        <div className="content-lpsoft ">
                            <label>Desarrollado por</label>
                            <img alt="LPSoft" src={logoLPSoftfrom} className="logo-small" />
                        </div>

                    </div>

                    {/*------Contenido de la imagen de la computadora e íconos------*/}
                    <ComputerWithLogo />
                </div>

                {/*------Triágulos Loop------*/}
                <div className="mask-burbuja">
                    <Burbujas />
                </div>

            </div>

            {/*------Modal para cerrar las sesiones activas en otros navegadores------*/}
            <ModalActiveSessionsList openModal={openModal} setOpenModal={setOpenModal} 
            sessionActiveData={sessionActiveData} onHandleReconnectionSession={onHandleReconnectionSession}/>

            {/*------Modal para cuando se cierra la sesion y muestre la desconexion del socket----*/}
            {/* <ModalSocketConnectionFailed /> */}

        </>
    )
};

export default Login;